module.exports = __webpack_public_path__ + "static/media/logo-marvel.7e98b410.jpg";